import * as React from 'react';
import cn from 'clsx';
import { ModalWindow, ArticleHeading2, ArticleHeading1, Button, Image } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';

import { withDeviceType, IWithDeviceTypeProps } from '../../../utils/withDeviceType';
import { createSrcSources, prepareSrcSets } from '../../../utils/srcSets';

import * as styles from './styles.css';

interface ICommonDealDetailsModalProps extends IWithDeviceTypeProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode | React.ReactNode[];
  picture?: Array<{ size: 'x1' | 'x2'; url: string }>;
}

export const DEFAULT_CLOSE_BUTTON_TEXT = 'Понятно';

/**
 * Модалка с часто встречающейся информацией о сделке.
 */
const CommonDealDetailsModal: React.FC<React.PropsWithChildren<ICommonDealDetailsModalProps>> = ({
  open,
  onClose,
  title,
  picture,
  children,
  isPhone,
  deviceType,
}) => {
  const srcSet = prepareSrcSets(picture);
  const sources = createSrcSources(srcSet);

  return (
    <ModalWindow open={open} onClose={onClose} width="100%" maxWidth={928}>
      <div className={cn(styles['container'], styles[deviceType])} data-testid="common-deal-details-modal">
        {srcSet && (
          <div className={styles['banner']}>
            <Image borderRadius="4px" objectFit="cover" display="block" src={srcSet.x1} sources={sources} />
          </div>
        )}
        <div className={styles['title']}>
          <ConditionalWrapper if={isPhone} ThenComponent={ArticleHeading2} ElseComponent={ArticleHeading1} as="h2">
            {title}
          </ConditionalWrapper>
        </div>
        <div className={cn(styles['content'], styles[deviceType])}>{children}</div>
        <div className={cn(styles['button'], styles[deviceType])}>
          <Button type="button" fullWidth={isPhone} onClick={onClose}>
            {DEFAULT_CLOSE_BUTTON_TEXT}
          </Button>
        </div>
      </div>
    </ModalWindow>
  );
};

const CommonDealDetailsModalWithDeviceType = withDeviceType(CommonDealDetailsModal);
export { CommonDealDetailsModalWithDeviceType as CommonDealDetailsModal };
